// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1035":"a43cf2e17eb3d413","3185":"8ef5ff5308c93ea6"}[chunkId] + ".css";
};